<template>
    <v-dialog
        v-model="showDialog"
        width="1200"
    >
        <v-card v-if="data">
            <v-data-table
                v-if="data && data.groupInfo && data.groupInfo.members"
                :items="data.groupInfo.members"
                :headers="headers"
                :search="search"
                class="msuListTbl"
                fixed-header
            >
                <template #top>
                    <v-card-title style="background-color: #009688; color: white;">
                        <v-chip style="font-weight: 700;">
                            {{ data.msuInfo.MSUGRP_ID }}
                        </v-chip>&nbsp; {{ data.msuInfo.MSUGRP_NAME }}
                        <v-spacer />
                        &nbsp;
                        <v-text-field
                            v-model="search"
                            style="width: 100px; background-color: white; border-radius: 5px;"
                            hide-details
                            dense
                            outlined
                            placeholder="Search ..."
                            color="black"
                            clearable
                        />
                        &nbsp;
                        <v-btn
                            color="success"
                            width="100"
                            @click="handleNewMsu"
                        >
                            <v-icon>{{ mdiPlus }}</v-icon> Add
                        </v-btn>
                        &nbsp;
                        <v-btn
                            color="error"
                            width="100"
                            @click="showDialog = false"
                        >
                            <v-icon>{{ mdiClose }}</v-icon> Close
                        </v-btn>
                    </v-card-title>
                </template>
                <template #item="{ item, index }">
                    <tr
                        @mouseenter="hoveredRow = index"
                        @mouseleave="hoveredRow = null"
                    >
                        <td
                            v-for="header in headers"
                            :key="header.value"
                            :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', textAlign: ['ACTIONS', 'hosp_msu_code'].includes(header.value) ? 'center' : '' }"
                        >
                            <span style="text-wrap: nowrap;">
                                <template v-if="header.value === 'ACTIONS'">
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="error"
                                                v-on="on"
                                                @click="deleteMsuFromGroup(item)"
                                            >
                                                <v-icon>{{ mdiTrashCan }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Remove from group</span>
                                    </v-tooltip>
                                </template>
                                <template v-else>
                                    {{ item[header.value] }}
                                </template>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <NewMsuFromGroup
                :show="showMsu.new.status"
                :data="showMsu.new.data"
                :notif="notif"
                @closeDialog="handleCloseDialog"
            />
            <DeleteMsuFromGroup
                :show="showMsu.delete.status"
                :data="showMsu.delete.data"
                :notif="notif"
                @closeDialog="handleCloseDeleteDialog"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import DeleteMsuFromGroup from './DeleteMsuFromGroup.vue'
import NewMsuFromGroup from './NewMsuFromGroup.vue'
import {
    mdiPlus,
    mdiClose,
    mdiTrashCan
} from '@mdi/js'

export default {
    components: { NewMsuFromGroup, DeleteMsuFromGroup },
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiPlus,
        mdiClose,
        mdiTrashCan,
        showMsu: {
            new: {
                status: false,
                data: {
                    msuInfo: [],
                    groupInfo: []
                }
            },
            delete: {
                status: false,
                data: null
            }
        },
        search: null,
        hoveredRow: null,
        headers: [
            { text: 'MSU Code', value: 'hosp_msu_code', align: 'center' },
            { text: 'Hospital/Clinic Name', value: 'hosp_name' },
            { text: 'Actions', value: 'ACTIONS', align: 'center', sortable: false }
        ]
    }),
    computed: {
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        show(newVal) {
            if (!newVal) {
                this.search = null
            }
        }
    },
    methods: {
        handleCloseSearchClinic() {
            this.search.status = false
            this.search.query = null
        },
        handleCloseDialog() {
            this.showMsu.new.status = false
        },
        handleNewMsu() {
            this.showMsu.new.data = this.data
            this.showMsu.new.status = true
        },
        handleCloseDeleteDialog() {
            this.showMsu.delete.data = null
            this.showMsu.delete.status = false
        },
        deleteMsuFromGroup(item) {
            this.showMsu.delete.data = {
                MSUGRP_ID: this.data.msuInfo.MSUGRP_ID,
                MSU_C: item.hosp_msu_code,
                info: {
                    group: this.data.msuInfo,
                    msu: item
                }
            }
            this.showMsu.delete.status = true
        }
    }
}
</script>

<style>
.msuListTbl > div > table > tbody > tr > td:last-child {
    position: sticky !important;
    right: 0;
    padding: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: white;
}
.msuListTbl .sticky-col {
  position: sticky;
  right: 0;
  background: white;
  z-index: 2;
  white-space: nowrap;
}
.msuListTbl .v-data-table__wrapper {
  overflow-y: auto;
  max-height: 70vh;
}
.msuListTbl > div > table > thead > tr > th:last-child {
    position: sticky !important;
    right: 0;
    z-index: 5 !important; /* Ensure the first column has a higher z-index */
    background: white;
}
</style>
